const themeConfig = {
  token: {
    colorPrimary: "#294DD8",
    colorSuccess: "#00874F",
    fontSize: 16,
    fontFamily: "Inter, sans-serif",
  },
  components: {
    Layout: {
      headerBg: "#ffffff",
      siderBg: "#14286D",
      bodyBg: "#ffffff",
      footerBg: "#F1F5FA",
    },
    Form: {
      fontSize: 14,
    },
    Input: {
      inputFontSize: 14,
      paddingBlock: 14,
      colorBorder: "#CBD5E2",
      colorTextPlaceholder: "#768EA7",
      borderRadius: 8,
    },
    Select: {
      fontSize: 14,
      colorBorder: "#CBD5E2",
      colorTextPlaceholder: "#768EA7",
      borderRadius: 8,
    },
    Button: {
      paddingInline: 24,
      paddingBlock: 24,
    },
    Card: {
      padding: 12,
      paddingLG: 20,
    },
    Checkbox: {
      colorBorder: "#B1C1D2",
      colorBgContainer: "#F5F8FF",
      controlInteractiveSize: 20,
      fontSize: 16,
      paddingXS: 15,
    },
    Segmented: {
      trackBg: "#ffffff",
      itemSelectedBg: "#ECF1FF",
      itemColor: "#768EA7",
      itemHoverBg: "#ffffff",
      itemSelectedColor: "#000000",
      borderRadius: 0,
      trackPadding: 4,
      controlHeight: 40,
      fontSize: 14,
    },
    Slider: {
      trackBg: "#00874F",
      railBg: "#E3EAF3",
      trackHoverBg: "#00874F",
      colorBgElevated: "#D0D8E0",
      handleColor: "#D0D8E0",
      handleActiveOutlineColor: "#00874F",
      handleSize: 12,
      handleSizeHover: 13,
    },
    Popover: {
      borderRadiusLG: 4,
    },
    Tooltip: {
      colorBgSpotlight: "#EBEBEB",
      colorTextLightSolid: "#2D2D2D",
      fontSize: 12,
    },
    Tabs: {
      itemSelectedColor: "#101924",
      inkBarColor: "#101924",
      itemColor: "#40566D",
      itemHoverColor: "#101924",
    },
    Table: {
      headerBg: "#F1F5FA",
      colorPrimaryBorder: "#CBD5E2",
      colorTextHeading: "#40566D",
      fontWeightStrong: 700,
    },
    Radio: {
      dotSize: 4,
      colorText: "#101924",
    },
    Spin: {
      colorBgMask: "rgba(0, 0, 0, 0.20)",
    },
    DatePicker: {
      fontSize: 14,
      inputFontSize: 14,
      paddingBlock: 12,
      colorBorder: "#CBD5E2",
      colorTextPlaceholder: "#768EA7",
      borderRadius: 8,
    },
  },
};

export default themeConfig;
